import { isLegacyEnabledStepsMode } from './resolveRequestFormSteps';
import {
  isOptionalRequestFormStepId,
  type RequestFormStepId,
} from '../config/requestFormStepRegistry';

export interface SidebarNavVisibilityOptions {
  stepVisibility: Readonly<Record<string, boolean | undefined>>;
  enabledStepIds: readonly string[];
  storedStepIds: string[] | null | undefined;
}

/**
 * Sidebar nav visibility (#997): RBAC may hide SA-only steps (e.g. Liquid Cooling in DRAFT),
 * but user-added optional scopes with explicit `enabled_step_ids` must still appear in nav.
 */
export function shouldShowStepInSidebarNav(
  stepId: string,
  options: SidebarNavVisibilityOptions,
): boolean {
  if (options.stepVisibility[stepId] !== false) {
    return true;
  }

  if (isLegacyEnabledStepsMode(options.storedStepIds)) {
    return false;
  }

  return (
    isOptionalRequestFormStepId(stepId) &&
    options.enabledStepIds.includes(stepId as RequestFormStepId)
  );
}

/**
 * Optional scopes addable via Add Scope even when RBAC hides step fields in DRAFT
 * (Requestor basic view). Matches sidebar nav bypass for user-added scopes (#997 #18).
 */
const ADD_SCOPE_RBAC_EXEMPT_STEP_IDS = new Set<RequestFormStepId>([
  'liquid-cooling',
]);

/** Hide RBAC-blocked optional scopes from the Add Scope picker (#997-1). */
export function filterAddableOptionalStepIdsByVisibility(
  addableStepIds: readonly RequestFormStepId[],
  stepVisibility: Readonly<Record<string, boolean | undefined>>,
): RequestFormStepId[] {
  return addableStepIds.filter(
    stepId =>
      ADD_SCOPE_RBAC_EXEMPT_STEP_IDS.has(stepId) ||
      stepVisibility[stepId] !== false,
  ) as RequestFormStepId[];
}
